import { formatBcomeVersionLabel } from "../../components/DbVersion";

// Update Version modes (IT-3586).
export const UPDATE_VERSION_MODES = {
  DOWNLOAD: "download",
  AUTO_UPLOAD: "autoUpload",
};

// Version Sets the auto-upload can be linked to: only active sets (the only ones the
// upload accepts) whose description is the traceability version the Excel is migrated
// to. Several sets can share a description (e.g. 1.8.2 on 1.8 and 1.8-bridge), so the
// user still picks one by id when there is more than one.
export const getVersionSetOptions = (bcomeVersionRecordMap, targetVersion) => {
  if (!targetVersion) return [];
  return Object.values(bcomeVersionRecordMap || {})
    .filter(
      (record) =>
        record?.isActive === true &&
        String(record.description ?? "").trim() === targetVersion
    )
    .map((record) => ({ id: record.id, label: formatBcomeVersionLabel(record) }));
};

export const FINAL_UPLOAD_STATUSES = ["SUCCESS", "PARTIAL", "FAILED"];

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// Polls an upload-history row until it reaches a final status. The auto-upload runs in
// background on the server, so this is how Admin learns the outcome.
// Resolves with the final row, or null when cancelled or when timeoutMs is reached
// (the work may still finish: Traceability status is the source of truth).
export const pollUploadHistory = async ({
  fetchRow,
  intervalMs = 5000,
  timeoutMs = 30 * 60 * 1000,
  isCancelled = () => false,
  now = () => Date.now(),
  sleep = wait,
}) => {
  const deadline = now() + timeoutMs;
  while (!isCancelled() && now() < deadline) {
    try {
      const row = await fetchRow();
      if (FINAL_UPLOAD_STATUSES.includes(row?.status)) return row;
    } catch (error) {
      // A transient network error must not stop the polling.
      console.warn("[traceability] upload status poll failed", error);
    }
    await sleep(intervalMs);
  }
  return null;
};
